var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from "react";
var TableRowExpand = function (props) {
    var id = props.id, style = props.style, className = props.className, children = props.children, parent = props.parent, onExpand = props.onExpand, onCollapse = props.onCollapse;
    var _a = __read(useState(false), 2), open = _a[0], setOpen = _a[1];
    var onClick = useCallback(function () {
        var openedStatus = !open;
        if (onExpand && openedStatus) {
            onExpand();
        }
        if (onCollapse && !openedStatus) {
            onCollapse();
        }
        setOpen(openedStatus);
    }, [onExpand, onCollapse, open]);
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { id: id, style: style, className: className, onClick: onClick }, parent),
        open && React.createElement(React.Fragment, null, children)));
};
export default TableRowExpand;
//# sourceMappingURL=DataTableRowExpand.js.map